<template>
  <button-answer
    :action="submit"
    :disabled="$store.state.answer.submit">
    {{ $l[title] }}
  </button-answer>
</template>

<script>
import MixinLocale from '@/components/MixinLocale'
import ButtonAnswer from '@/components/Button'

export default {
  mixins: [
    MixinLocale
  ],

  components: {
    ButtonAnswer
  },

  computed: {
    title: function () {
      if (this.$store.state.answer.submit) {
        return 'answerSubmitted'
      }
      return 'answerSubmit'
    }
  },

  methods: {
    submit: function () {
      if (window.confirm(this.$l['answerSubmitConfirm'])) {
        this.$store.dispatch('answer/submit')
      }
    }
  }
}
</script>
